// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"378":"management","594":"about"}[chunkId] || chunkId) + "." + {"378":"8d77d62c","516":"3ec8d7ca","594":"8b2aa894"}[chunkId] + ".js";
};